module.exports = __webpack_public_path__ + "static/media/Akshat Narayan Gupta.113a32a2.jpeg";